export const ENTERPRISE_ADMIN_ROLES = {
  MENTOR_LITE: 'MENTOR_LITE',
  MENTOR: 'MENTOR',
  PII_RESTRICTED_ADMIN: 'PII_RESTRICTED_ADMIN',
  ORG_ADMIN: 'ORG_ADMIN',
  PROGRAM_ADMIN: 'PROGRAM_ADMIN',
} as const;

export type EnterpriseAdminRole = (typeof ENTERPRISE_ADMIN_ROLES)[keyof typeof ENTERPRISE_ADMIN_ROLES];

export type EnterpriseAdminRolePermissions = {
  [id: string]: SubdomainPermissions;
};

export const ENTERPRISE_ADMIN_PERMISSION_SUBDOMAIN = {
  DEFAULT_SUBDOMAIN: 'DEFAULT_SUBDOMAIN',
  ANALYTICS: 'ANALYTICS',
  BUSINESS_API: 'BUSINESS_API',
  CONTRACTS: 'CONTRACTS',
  GRADEBOOK: 'GRADEBOOK',
  COMMUNICATIONS: 'COMMUNICATIONS',
  CURRICULUM: 'CURRICULUM',
  LEARNERS: 'LEARNERS',
  SETTINGS: 'SETTINGS',
  LEADERBOARD: 'LEADERBOARD',
  SKILLSETS: 'SKILLSETS',
  LEVELSETS: 'LEVELSETS',
  PII: 'PII',
  PROGRAM: 'PROGRAM',
  USAGE_REPORT: 'USAGE_REPORT',
  CUSTOM_COURSES: 'CUSTOM_COURSES',
  ADMINS: 'ADMINS',
  CONTENT_ASSIGNMENT: 'CONTENT_ASSIGNMENT',
  SELF_SERVE_CONTRACTS: 'SELF_SERVE_CONTRACTS',
  SSO: 'SSO',
  RECRUITMENT_PIPELINE: 'RECRUITMENT_PIPELINE',
} as const;

export type EnterpriseAdminPermissionSubdomain =
  (typeof ENTERPRISE_ADMIN_PERMISSION_SUBDOMAIN)[keyof typeof ENTERPRISE_ADMIN_PERMISSION_SUBDOMAIN];

export const ENTERPRISE_ADMIN_PERMISSION_VERB = {
  VIEW: 'VIEW',
  EDIT: 'EDIT',
  MANAGE: 'MANAGE',
  CREATE: 'CREATE',
  EXPORT: 'EXPORT',
  ARCHIVE: 'ARCHIVE',
} as const;

export type EnterpriseAdminPermissionVerb =
  (typeof ENTERPRISE_ADMIN_PERMISSION_VERB)[keyof typeof ENTERPRISE_ADMIN_PERMISSION_VERB];

export type SubdomainPermissions = {
  [subdomain in EnterpriseAdminPermissionSubdomain]?: Set<EnterpriseAdminPermissionVerb>;
};

export type RequiredPermission = {
  domain: 'ORGANIZATION' | 'PROGRAM' | 'ANY_PROGRAM'; // no domainId expected if domain is ANY_PROGRAM
  domainId?: string;
  subdomain?: EnterpriseAdminPermissionSubdomain;
  verb: EnterpriseAdminPermissionVerb;
};
